<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading && localDrug">
      <form action="" @submit.prevent="createOrder">
        <div class="text-left">
          <OrderedInvoices
            v-if="ordered.length"
            :orders="ordered"
            :costPrice="costPrice"
            :suppliers="suppliers"
          />
        </div>
        <div class="text-left">
        </div>
        <table class="table table-hover table-sm mt-1">
          <thead>
          <tr>
            <th></th>
            <th>
              Поставщик
            </th>
            <th></th>
            <th>Скидка %</th>
            <th>Цена</th>
            <th>Ц. Скидка</th>
            <th>Кол</th>
            <th>Сумма</th>
            <th class="comment_block"></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <!--          <tr v-for="(o, i) in newOrder" :class="{'ordered': o.ordered}">-->
          <!--          <tr v-for="(o, countryId) in getSortedOrders()" :class="{'ordered': o.ordered}">-->
          <template v-if="!Object.keys(getSortedOrders()).length">
            <tr>
              <td colspan="15"><p>Нет активных поставщиков страны закупки препарата</p></td>
            </tr>
          </template>
          <template v-else v-for="(orders, cId_text) in getSortedOrders()" :class="{'ordered': o.ordered}">
            <tr class="country_tr">
              <td colspan="20">{{ $AllCountries[orders.country_id].name }}</td>
            </tr>
            <tr v-for="o in orders.orders" :class="{'ordered': o.ordered}">
              <template v-if="!o.toDelete">
                <td>
                  <i v-if="o.ordered" class="icon-fa icon-fa-check-circle"/>
                </td>
                <td>
                  <select disabled v-model="o.supplier.id" class="form-control">
                    <option v-for="s in suppliers" :value="s.id">{{ s.title }}
                      ({{ $AllCountries[s.country_id] && $AllCountries[s.country_id].title }})
                      <span
                        v-if="drugPrices && drugPrices[s.id]">{{
                          printDate(drugPrices[s.id].updated_at, 'DD/MM')
                        }}</span>
                    </option>
                  </select>
                </td>
                <td v-if="false">
                  <v-popover
                    placement="left"
                    trigger="hover"
                  >
                    <i class="icon-fa icon-fa-info-circle pointer"/>
                    <template slot="popover">
                      <template v-if="invoices[o.supplier.id]">
                        <p>накладная <strong>{{ invoices[o.supplier.id].id }}</strong></p>
                        <p>{{ printDate(invoices[o.supplier.id].delivery_date) }}
                          <strong>{{ invoices[o.supplier.id].income_price }}</strong></p>
                      </template>
                      <template v-else>
                        <p>накладная поступления не найдена</p>
                      </template>
                    </template>
                  </v-popover>
                </td>
                <td>
                  <div class="flex">
                    <a
                      v-if="drugPrices[o.supplier.id]?.link"
                      class="mr-1"
                      :href="`${drugPrices[o.supplier.id].link}`"
                      target="_blank"><i class="icon-fa icon-fa-globe"></i></a>
                    <span v-if="drugPrices[o.supplier.id]?.extra_data?.outOfStore"
                          class="badge badge-warning mr-1">нет в наличии</span>
                    <span v-if="drugPrices[o.supplier.id]?.pzn && !drugPrices[o.supplier.id]?.extra_data?.productExist"
                          class="badge badge-danger mr-1">не активный</span>
                    <v-popover
                      v-if="drugPrices[o.supplier.id]?.error"
                      placement="right"
                      trigger="hover"
                    >
                      <i class="color_dark_red pointer icon-fa icon-fa-warning"></i>
                      <template slot="popover">
                        {{ drugPrices[o.supplier.id].error }}
                      </template>
                    </v-popover>
                  </div>
                </td>
                <td>
                  {{ getSupplierDiscount(o.supplier.id) }}
                </td>
                <td>
                  <input @keyup="updatePriceDecimal(o)" v-model="o.price" class="form-control">
                </td>
                <td>
                  <input type="number" disabled
                         :value="discountedPrice(o)"
                         class="form-control">
                </td>
                <td>
                  <input ref="newQty" type="number" v-model="o.qty" class="form-control">
                </td>
                <td>
                  <input type="number" disabled :value="discountedPrice(o) * o.qty" class="form-control">
                </td>
                <td>
                  <div class="text-left">
                    <div class="form-group mb-0">
                      <input type="checkbox" :id="`ch_d_${o.supplier.id}`" @change="updateDateComment(o.supplier.id)"
                             v-model="o.useExpireDateComment">
                      <label class="pl-2 pointer" :for="`ch_d_${o.supplier.id}`">Комм. срока годности</label>
                    </div>
                    <div class="ml-3 flex" v-if="o.useExpireDateComment">
                      <div class="mr-1">
                        <div>
                          <input class="form-check-input" @change="updateDateComment(o.supplier.id)" type="radio"
                                 v-model="o.commentType" :id="`inlineRadio${o.supplier.id}_1`" value="1">
                          <label class="form-check-label" :for="`inlineRadio${o.supplier.id}_1`">Дата больше</label>
                        </div>
                        <div>
                          <input class="form-check-input" @change="updateDateComment(o.supplier.id)" type="radio"
                                 v-model="o.commentType" :id="`inlineRadio${o.supplier.id}_2`" value="2">
                          <label class="form-check-label" :for="`inlineRadio${o.supplier.id}_3`">Выбор года</label>
                        </div>
                        <div>
                          <input class="form-check-input" @change="updateDateComment(o.supplier.id)" type="radio"
                                 v-model="o.commentType" :id="`inlineRadio${o.supplier.id}_3`" value="3">
                          <label class="form-check-label" :for="`inlineRadio${o.supplier.id}_3`">Текст</label>
                        </div>
                      </div>
                      <div>
                        <input type="text" v-model="o.expireDateComment" class="form-control">
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                </td>
              </template>
            </tr>
          </template>
          </tbody>
        </table>
        <input type="submit" hidden/>
      </form>
    </template>
    <table v-if="false" class="table table-sm table-hover">
      <thead>
      <tr>
        <th>PZN</th>
        <th v-for="(supp, ii) in suppliers" :key="`s_${ii}`">
          {{ supp.title }}
          <p class="text-muted">max: {{ supp.max_qty }}</p>
        </th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(price, pzn, i) in prices" :key="i">
        <td><strong>{{ pzn }}</strong>
          <p v-if="pznDetails && pznDetails[pzn] && pznDetails[pzn].comment">{{
              pznDetails[pzn].comment.text_value
            }}</p>
        </td>
        <td v-for="(supp, ii) in suppliers" :key="`s_${ii}_${i}`">
          <template v-if="price[supp.id] && price[supp.id].price">
            <p>цена: <span v-bind:class="{'badge': true, 'badge-success': costPrice > price[supp.id].price}"><strong
              class="price">{{ price[supp.id].price }}</strong></span>
              <a :href="`${price[supp.id].link}`" target="_blank"><i class="icon-fa icon-fa-globe"/></a>
            </p>
            <p class="text-muted">{{ printDate(price[supp.id].updated_at, 'DD.MM.YYYY HH:mm') }}</p>
            <input @change="updateTotalOrder(pzn)" v-model="orderQty[pzn][supp.id].qty" type="number"
                   class="form-control">
          </template>
        </td>
        <td>
          <p>требуется: <strong>{{ requiredQty }}</strong></p>
          <p>заказ: <strong>{{ totalOrdered[pzn] }}</strong></p>
          <button type="button" @click="makeSmartOrder(pzn)" class="btn btn-default btn-xs">Распределить</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from "@/api";
import OrderedInvoices from "@/views/nomenclature/components/details/OrderedInvoices";
import moment from 'moment';
import {updateOrderedDrugs} from "@/eventsBus/index";

export default {
  components: {OrderedInvoices},
  props: ['drug', 'countrySelected', 'drugDetails', 'updateOrderDrug', 'costPrice', 'prices', 'requiredQty', 'pznDetails', 'closeModal'],
  data() {
    return {
      loading: true,
      orderQty: {},
      drugPrices: {},
      newOrder: [],
      parsedPrices: [],
      ordered: [],
      localDrug: null,
      totalOrdered: {},
      suppliers: null,
      invoices: null,
      saving: false,
      useExpireDateComment: false,
      commentType: 1,
      expireDateComment: '',
    }
  },
  created() {
    // this.initQty();
    this.getDrugInfo();
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {})
    },
  },
  watch: {
    'requiredQty': {
      handler: function (val, oldVal) {
        this.updateOrderQty();
      }
    },
    // 'commentType': {
    //   handler: function (val, oldVal) {
    //     this.updateDateComment();
    //   }
    // }
  },
  methods: {
    updatePriceDecimal(order) {
      const index = this.newOrder.findIndex((o) => o.supplier.id === order.supplier.id);
      if (index !== -1) {
        this.newOrder[index].price = this.newOrder[index].price.replace(',', '.');
      }
    },
    getSortedOrders() {
      const list = {};
      if (this.countrySelected) {
        list[this.countrySelected + '_country'] = {orders: [], country_id: this.countrySelected};
      }
      const orders = _.orderBy(this.newOrder, 'ordered');
      return orders.reduce((acc, o) => {
        // const newList = orders.reduce((acc, o) => {
        if (!acc[o.supplier.country_id + '_country']) acc[o.supplier.country_id + '_country'] = {
          orders: [],
          country_id: o.supplier.country_id
        };
        acc[o.supplier.country_id + '_country'].orders.push(o);
        return acc;
      }, list);
      // return newList;
    },
    updatePriceBySupplier(index) {
      // const suppId = this.newOrder[index].supplier.id;
      // this.newOrder[index].price = this.invoices[suppId] && this.invoices[suppId].income_price || 0;
    },
    discountedPrice(o) {
      const s = this.suppliers[+o.supplier.id];
      return Math.round((o.price - (+(s && s.options && s.options.discount || 0) * o.price / 100)) * 100) / 100;
    },
    getSupplierDiscount(id) {
      const s = this.suppliers[id];
      if (s) {
        return s.options && s.options.discount || 0;
      }
    },
    updateDateComment(supplierId) {
      const index = this.newOrder.findIndex((o) => o.supplier.id === supplierId);
      console.log(supplierId, index);
      const record = this.newOrder[index];
      switch (+record.commentType) {
        case 1:
          if (this.drug.valid_dates && this.drug.valid_dates.length) {
            const expDate = this.drug.valid_dates.reduce((acc, d) => {
              if (!acc) acc = {...d}
              if (moment(acc.expire_date) < moment(d.expire_date)) {
                acc = {...d};
              }
              return acc
            }, null)
            record.expireDateComment = '> ' + moment(expDate.expire_date).subtract(1, 'month').format('MM.YYYY');
          } else {
            record.expireDateComment = '> ' + moment().add(1, 'years').format('MM.YYYY');
          }
          break;
        case 2:
          if ((moment().month() + 1) > 5) {
            record.expireDateComment = moment().add(2, 'years').format('YYYY');
          } else {
            record.expireDateComment = moment().add(1, 'years').format('YYYY');
          }
          break;
        case 3:
          record.expireDateComment = 'Best EXP';
          break;
      }
      this.newOrder[index] = record;
    },
    async createOrder() {
      if (this.saving) return;
      if (!this.newOrder.length) {
        toastr['warning']('Нет данных для заказа');
        return;
      }
      if (!this.drug.en_title) {
        toastr['warning']('Укажите наименование на английском');
        return;
      }
      const supplierCheck = {};
      let error = false;
      // this.newOrder.forEach((o) => {
      //   if (!o.toDelete && (!(+o.qty) || o.qty <= 0)) {
      //     toastr['warning']('Количество не указано');
      //     error = true;
      //   }
      // });
      if (error) return;
      this.saving = true;
      const {data} = await api.post('/invoices/order/drug', {
        drug_id: this.drug.id,
        drug: {...this.localDrug, en_title: this.drug.en_title, purchase_comment: this.drug.purchase_comment},
        drugDetails: this.drugDetails,
        records: this.newOrder,
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено', 'Успешно')
        updateOrderedDrugs.$emit('updateOrderedDrugs', {});
        if (this.updateOrderDrug) {
          this.updateOrderDrug(data.savedInvoices, {...this.localDrug, en_title: this.drug.en_title})
        }
        if (this.closeModal) {
          this.closeModal();
        }
      } else {
        toastr['error'](data.message || 'Ошибка')
      }
      this.saving = false;
    },
    removeOrder(index) {
      this.newOrder[index].toDelete = true;
    },
    updateOrderQty() {
      let i = this.newOrder.findIndex((o) => o.qty || o.supplier.use_default);
      if (i === -1) i = 0;
      this.newOrder.forEach((o) => {
        o.qty = 0;
      })
      this.newOrder[i].qty = this.requiredQty;
    },
    async getDrugInfo() {
      this.loading = true;
      const {data} = await api.index('/new/suppliers/order/prices/' + this.drug.id);
      if (data.success) {
        this.ordered = data.ordered.reduce((acc, o) => {
          if (o.comments) {
            o.comments = JSON.parse(o.comments);
          }
          acc[o.supplier_id] = o;
          return acc;
        }, {});
        // this.parsedPrices = data.parsedPrices;
        const suppliers = data.suppliers.reduce((acc, s) => {
          acc[s.id] = s;
          return acc;
        }, {});

        this.localDrug = data.drug;
        this.suppliers = suppliers;
        // this.parsedPrices = parsedPrices;
        this.drugPrices = data.prices;
        this.invoices = data.invoices.reduce((acc, i) => {
          acc[i.supplier_id] = i;
          return acc;
        }, {});
        // if (!this.ordered.length) {
        let foundDefault = false
        Object.values(this.suppliers).forEach((s) => {
          if (s.use_default) {
            // if (!this.ordered.find((o) => o.supplier_id === s.id)) {
            foundDefault = s;
            // }
          }
        })
        if (!foundDefault) {
          foundDefault = Object.values(this.suppliers)[0];
        }
        if (foundDefault) {
          this.addRecordBySupplier(foundDefault);
          data.suppliers.forEach((s) => {
            if (s.id !== foundDefault.id) {
              this.addRecordBySupplier(s, 0);
            }
          })
          setTimeout(() => {
            this.$refs.newQty[0].focus()
          }, 300)
          // this.updateDateComment(0);
        }
        this.drug.infoPrices = Object.values(data.prices).filter((p) => p.supplier.type_id === 2); //info suppliers
      } else {
        toastr['warning'](data.message || 'message');
      }
      this.loading = false;
    },
    addRecordBySupplier(s = null, reqQty = null) {
      const arr = {
        supplier: s || {id: 0},
        ordered: this.ordered[s.id] || null,
        invoice: s?.id ? this.drugPrices[s.id] && this.drugPrices[s.id].invoice_id || null : null,
        // price: s && this.invoices[s.id] && this.invoices[s.id].income_price || 0,
        price: s?.id ? this.drugPrices[s.id] && this.drugPrices[s.id].price || 0 : 0,
        qty: reqQty !== null ? reqQty : this.requiredQty,
        useExpireDateComment: false,
        commentType: 1,
        expireDateComment: '',
        toDelete: false,
      };
      if (this.ordered[s.id]) {
        arr.price = this.ordered[s.id].income_price;
        arr.qty = +this.ordered[s.id].qty;
        if (this.ordered[s.id].comments) {
          const index = this.ordered[s.id].comments.length - 1;
          if (this.ordered[s.id].comments[index]) {
            arr.commentType = this.ordered[s.id].comments[index].comment_type;
            arr.expireDateComment = this.ordered[s.id].comments[index].text;
            arr.useExpireDateComment = true;
          }
        }
      }
      this.newOrder.push(arr)
    },
    initQty() {
      this.totalOrdered = Object.keys(this.prices).reduce((acc, pzn) => {
        acc[pzn] = 0;
        return acc;
      }, {})
      this.orderQty = Object.keys(this.prices).reduce((acc, pzn) => {
        acc[pzn] = Object.keys(this.prices[pzn]).reduce((acc, supp) => {
          acc[supp] = {qty: 0, price: this.prices[pzn][supp].price};
          return acc;
        }, {})
        return acc;
      }, {})
    },
    updateTotalOrder(pzn) {
      this.totalOrdered[pzn] = Object.values(this.orderQty[pzn]).reduce((acc, o) => acc + +o.qty, 0);
    },
    makeSmartOrder(pzn, qty = null) {
      if (qty === null) qty = this.requiredQty;
      let supplier = this.findLowerSupplierPrice(pzn);
      if (supplier) {
        qty = this.setQtyBySupplier(pzn, supplier, +qty);
        if (qty > 0) {
          while (supplier && qty > 0) {
            supplier = this.findLowerSupplierPrice(pzn);
            if (supplier) qty = this.setQtyBySupplier(pzn, supplier, qty);
          }
        }
      }
      this.updateTotalOrder(pzn);
    },
    setQtyBySupplier(pzn, supplier, qty) {
      this.orderQty[pzn][supplier.supplier_id].qty = qty > +this.suppliers[supplier.supplier_id].max_qty ? +this.suppliers[supplier.supplier_id].max_qty : qty;
      qty -= this.orderQty[pzn][supplier.supplier_id].qty;
      return qty;
    },
    findLowerSupplierPrice(pzn) {
      let supplier = null;
      Object.values(this.prices[pzn]).forEach((p) => {
        if (supplier === null) {
          if (this.orderQty[pzn][p.supplier_id].qty < +this.suppliers[p.supplier_id].max_qty) {
            supplier = {...p};
          }
        }
        if (supplier && +p.price < +supplier.price && this.orderQty[pzn][p.supplier_id].qty < +this.suppliers[p.supplier_id].max_qty) {
          supplier = {...p};
        }
      })
      return supplier;
    }
  }
}

</script>

<style scoped>
table.table tr.ordered {
  background-color: #00ac0033;
}

table.table tr.ordered .icon-fa {
  color: green;
}

table.table td {
  text-align: left;
  padding: 3px;
}

.price {
  font-size: 18px;
}

.comment_block {
  width: 325px;
}

.text-muted {
  font-size: 12px;
}

.country_tr td {
  font-size: 16px;
  font-weight: 500;
}

.country_tr {
  background-color: #e2e2e2;
}
</style>
